import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from "../api.js";
import { toast } from 'react-toastify';

export const GetVendorCategorySlice = createAsyncThunk("admin/vendor-category-list",async (params, { rejectWithValue }) => {
    try {
      const response = await api.GetVendorCategoryApi(params);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const GetVendorCategoryListDropDownSlice = createAsyncThunk("admin/vendor-category-listing",async (_, { rejectWithValue }) => {
    try {
      const response = await api.GetVendorCategoryListForDropDownApi();
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const CreateVendorCategorySlice = createAsyncThunk('admin/vendor-category-insert',async (data, { rejectWithValue }) => {
  try {
    const response = await api.CreateVendorCategoryApi(data);
      return response.data;
    } catch (error) {
    console.error("API error:", error);
    return rejectWithValue(error.response?.data || { message: "An error occurred" });
  }
}
);

export const EditVendorCategorySlice = createAsyncThunk('admin/vendor-category-update/id',async (data, { rejectWithValue }) => {
  try {
    const response = await api.EditVendorCategoryApi(data);
      return response.data;
    } catch (error) {
    console.error("API error:", error);
    return rejectWithValue(error.response?.data || { message: "An error occurred" });
  }
}
);

export const DeleteVendorCategorySlice = createAsyncThunk('admin/vendor-category-delete/id',async (id, { rejectWithValue }) => {
  try {
    const response = await api.DeleteVendorCategoryApi(id);
      return response.data;
    } catch (error) {
    console.error("API error:", error);
    return rejectWithValue(error.response?.data || { message: "An error occurred" });
  }
}
);

const VendorCategoryManagementSlice = createSlice({
  name: 'VendorCategoryManagement',
  initialState: {
    VendorCategoryList: [],
    CategoryListDropDown: [],
    createdCategory: [],
    EditedCategory: [],
    DeleteCategory: [],
    loading: false,
    error: null,
    validationErrors: [],
  },
  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null;
      state.validationErrors = [];
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || [];
    }

    builder
      .addCase(GetVendorCategorySlice.pending,handlePendingState)
      .addCase(GetVendorCategorySlice.fulfilled, (state, action) => {
        state.VendorCategoryList = action.payload.data;
        state.loading = false;
      })
      .addCase(GetVendorCategorySlice.rejected,handleRejectState)

      .addCase(GetVendorCategoryListDropDownSlice.pending,handlePendingState)
      .addCase(GetVendorCategoryListDropDownSlice.fulfilled, (state, action) => {
        state.CategoryListDropDown = action.payload.data;
        state.loading = false;
      })
      .addCase(GetVendorCategoryListDropDownSlice.rejected,handleRejectState)

      .addCase(CreateVendorCategorySlice.pending,handlePendingState)
      .addCase(CreateVendorCategorySlice.fulfilled, (state, action) => {
        state.createdCategory = action.payload.data;
        state.loading = false;
        toast.success("Vendor Category is Created!");
      })
      .addCase(CreateVendorCategorySlice.rejected,handleRejectState)

      .addCase(EditVendorCategorySlice.pending,handlePendingState)
      .addCase(EditVendorCategorySlice.fulfilled, (state, action) => {
        state.EditedCategory = action.payload.data;
        state.loading = false;
        toast.success("Vendor Category is Updated!");
      })
      .addCase(EditVendorCategorySlice.rejected,handleRejectState)

      .addCase(DeleteVendorCategorySlice.pending,handlePendingState)
      .addCase(DeleteVendorCategorySlice.fulfilled, (state, action) => {
        state.DeleteCategory = action.payload.data;
        state.loading = false;
        toast.success("Vendor Category is Deleted!");
      })
      .addCase(DeleteVendorCategorySlice.rejected,handleRejectState);
  },
});

export default VendorCategoryManagementSlice.reducer;
